// CONF
import { UpdateConf } from './conf/Update.conf';
// REDUX
import { reducer, actions, editSelector } from './slice';

// SELECTOR
import { tag } from './slice';

// SAGA
import { saga } from './saga';

// API
import { API } from './api';
import { DetailConf } from './conf/Detail.conf';

export { reducer, saga, tag };

const deliveryNote = {
  tag,
  query: {
    all: {
      settings: API.allDeliveryNotes,
      populate: '*',
    },
    detail: {
      action: actions.fetchDetailAction,
      settings: API.deliveryNotes,
      populate: '*',
    },
    edit: {
      settings: API.update,
    },
    PDF: {
      settings: API.downloadPDF,
    },
  },
  edit: {
    conf: UpdateConf,
    selector: {
      data: editSelector,
    },
  },

  detail: {
    conf: DetailConf,
    edit: {
      to: 'edit',
    },
  },
};

export default deliveryNote;
